// client/src/hooks/useAuth.js
import { useEffect, useState } from 'react';
import { useUser } from '@clerk/clerk-react';

export function useAuth() {
  const { user, isSignedIn, isLoaded } = useUser();
  const [isInitialized, setIsInitialized] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Only run this when the user is signed in and clerk has loaded
    if (isLoaded && isSignedIn && user && !isInitialized) {
      // Check if this is a new sign-up or login by looking for user record
      const createUserIfNeeded = async () => {
        try {
          console.log('Initializing user in database:', user.id);
          
          // Call your API to create/verify user
          const response = await fetch('/api/create-user', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              clerkId: user.id,
              email: user.primaryEmailAddress?.emailAddress
            }),
          });
          
          if (!response.ok) {
            const errorData = await response.json();
            console.error('Failed to create user record:', errorData);
            setError(errorData.error || 'Failed to create user record');
          } else {
            const userData = await response.json();
            console.log('User initialized in database:', userData);
            setIsInitialized(true);
          }
        } catch (error) {
          console.error('Error creating user:', error);
          setError(error.message || 'Error creating user');
        }
      };
      
      createUserIfNeeded();
    }
  }, [isLoaded, isSignedIn, user, isInitialized]);
  
  return { user, isSignedIn, isLoaded, error, isInitialized };
}